/* eslint-disable react/prop-types */
import React, { useState, useEffect, MouseEvent } from "react";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import FormGroup from '@mui/material/FormGroup';


import MDBox from "components/MDBox";

import MDTypography from "components/MDTypography";

import moment from "moment";
import { getPackages } from "network/service";
import DataTable from "examples/Tables/DataTable";

let status_titles = {
    0: "Pending",
    5: "Picked Up",
    1: "Intransit",
    2: "On Hold",
    3: "Delivered",
    4: "Issue"
}

let dashboardTableHeader = [
    { Header: "Date & Time", accessor: "time" },
    { Header: "Capex awb no", accessor: "tracking_number_internal" },
    { Header: "Customer name", accessor: "cname" },
    { Header: "Receiver name", accessor: "rname" },
    { Header: "Branch", accessor: "bName" },
    { Header: "Carrier", accessor: "carrier" },
    { Header: "AWB", accessor: "awb" },
    { Header: "Weight", accessor: "weight" },
    { Header: "No. Boxes", accessor: "boxes" },
    { Header: "Status", accessor: "status" },
];


// Material Dashboard 2 React Components
function ParcelHistory(props) {
    const [notiDetails, setShowDetails] = useState({ show: false });
    const [loading, setLoading] = useState(false);
    const [dElems, setDelems] = useState([]);



    const closeSB = () => setShowDetails({ ...notiDetails, show: false });

    async function formDashboardTableRow(arr) {
        let result;
        result = [];
        for (const ele of arr) {
            const temp = {
                time: new Date(ele.createdAt).toLocaleString(),
                tracking_number_internal: (
                    <a href={`https://capexcourier.com/track/?tracking=${ele.tracking_number_internal}`} target="_blank" rel="noopener noreferrer">{ele.tracking_number_internal}</a>
                ),
                cname: ele.from.name,
                rname: ele.to.name,
                bName: ele.branch.name,
                carrier: ele.carrier.name,
                awb: ele.tracking_number,
                weight: ele.total_weight,
                boxes: ele.boxes.length,
                status: `${status_titles[ele.status]}`
            };
            result.push(temp);
        }
        setDelems(result.reverse());
    }

    useEffect(() => {
        if (props.isOpen) {
            setLoading(true);
            getPackages(`from.phone=${props.details?.phone}`).then((resp) => {
                setLoading(false);
                console.log(resp.data);
                formDashboardTableRow(resp.data);
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            })
        }
    }, [props.isOpen, setLoading]);



    return (
        <Dialog
            id="modal-display"
            open={props.isOpen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            onClose={props.handleclose}
        >
            <DialogContent style={{ height: 'auto' }}>
                <FormGroup>
                    <MDBox component="form" noValidate width="100%">
                        <MDTypography
                            variant="h5"
                            fontWeight="bold"
                            color="dark"
                        >
                            {"Transactions"}
                        </MDTypography>
                        <MDBox pt={0}>
                            <DataTable
                                table={{ columns: dashboardTableHeader, rows: dElems }}
                                canSearch
                            />
                        </MDBox>
                    </MDBox>
                </FormGroup>
            </DialogContent>
        </Dialog >
    )
};

export default ParcelHistory;